import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../../../services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '../../../../../styles/hooks/useModifiers';
import type { AutoplayButtonProps } from '../../buttons/base/AutoplayButton';
import { AutoplayButton } from '../../buttons/base/AutoplayButton';

import styles from './AutoplayModifyButton.module.css';

export interface AutoplayModifyButtonProps extends AutoplayButtonProps {
  addOn: number;
  totalBet: ReactElement | string;
}

export const AutoplayModifyButton: FC<AutoplayModifyButtonProps> = ({ addOn, totalBet, className, ...rest }) => {
  const mods = useModifiers(styles, 'autoplayModifyBtn', {}, { withBaseClass: true, extraClassName: className });
  return (
    <AutoplayButton className={mods} {...rest}>
      <div className={styles.autoplayModifyBtn__info}>
        <span className={styles.autoplayModifyBtn__addOn}>
          {'+'}
          {addOn}
        </span>
        <span className={styles.autoplayModifyBtn__roundText}>
          <L10nText tk="ROUNDS" />
        </span>
      </div>
      <span className={styles.autoplayModifyBtn__totalBet}>{totalBet}</span>
    </AutoplayButton>
  );
};
